var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperatingInstructions"},[_c('div',{staticClass:"hearderBox"},[_c('span',{on:{"click":_vm.backPath}},[_c('Svgs',{attrs:{"name":"iconfanhui","color":"#000"}})],1),_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]),_c('div',{class:[
      'OperatingInstructionsContent',
      _vm.isType == 'trainingMaterials' && 'rocheOperatingInstruction',
    ]},[_c('Field',{attrs:{"fieldList":_vm.fieldList},on:{"call-back":_vm.fieldCall}}),(_vm.isFirst)?_c('Skeleton',{attrs:{"skList":_vm.skList}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }